import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import UserUtils from 'src/services/utils/UserUtils';

const userUtils = new UserUtils();

export const getMailboxRoleAccess = (user) => {
    const isAnalystAdmin = userUtils.isAnalystAdmin(user);
    const isRestrictedAnalyst = userUtils.isAnalyst(user) && !isAnalystAdmin;

    return {
        isAnalystAdmin,
        isRestrictedAnalyst,
        canComposeNew: !isRestrictedAnalyst,
        canSyncMailbox: !isRestrictedAnalyst,
        canOpenSettings: !isRestrictedAnalyst,
        canApplyIntents: !isRestrictedAnalyst,
    };
};

const useMailboxRoleAccess = () => {
    const user = useSelector((state) => state.Login?.user);

    return useMemo(() => getMailboxRoleAccess(user), [user]);
};

export default useMailboxRoleAccess;
